import StatementTable from "/src/features/dataset/components/table/StatementTable/StatementTable";

function StatementList() {
    
    return <StatementTable/>
}

export default StatementList;